const url = new URL(window.location);
if (url.pathname === "/account/login") {
  const el = document.querySelector('#customer_login input[name="return_url"]');
  if (el) {
    const [path, originalParams] = el.value.split("?");
    const newParams = new URLSearchParams(originalParams);
    newParams.set("from_login", true);
    el.value = `${path}?${newParams}`;
  } else {
    const searchParams = url.searchParams;
    const returnUrl = searchParams.get("return_url");
    const checkoutUrl = searchParams.get("checkout_url");
    const hasRecoverHash = !!window.location.hash.match(/#recover/);
    const hasSuccessMessage = !!document.querySelector(".js-recover-success");

    if (!returnUrl && !checkoutUrl && !hasRecoverHash && !hasSuccessMessage) {
      window.location.href = "/account/login?return_url=%2Faccount";
    }
  }
}

if (
  url.pathname === "/account" &&
  url.searchParams.get("from_login") === "true"
) {
  const user = theme.customer;
  const eventData = {
    "customer - logged in": user.isLoggedIn,
    "customer - shopify id": user.id,
    "customer - email": user.email ? user.email : "",
    "customer - total orders":
      user.orders_count || user.orders_count === 0 ? user.orders_count : "",
    "customer - total spent":
      user.total_spent || user.total_spent === 0
        ? (user.total_spent / 100).toFixed(2)
        : "",
  };

  window.maestro.fireTrackEvent("submitLoginForm", eventData);
  url.searchParams.delete("from_login");
  history.replaceState({}, "", url);
}
